// MicVideoButtons.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NULL_FUNCTION, EMPTY_OBJECT } from '../resource/defaults.js';
import { ButtonId } from '../resource/trackingConstants.js';
import { color } from '../style/variables.js';

import MicrophoneFillIconSrc from '../../img/ic-mic-on.svg';
import MicrophoneSlashFillIconSrc from '../../img/ic-mic-off.svg';
import VideoFillIconSrc from '../../img/ic-camera-on.svg';
import VideoSlashFillIconSrc from '../../img/ic-camera-off.svg';

const MicVideoButtons = ({
  isAudioOn = true,
  isVideoOn = true,
  hasBorder = false,
  trackingPayload = EMPTY_OBJECT,
  onToggleAudio = NULL_FUNCTION,
  onToggleVideo = NULL_FUNCTION,
}) => (
  <>
    <ControlButton
      data-no-drag
      data-element_id={
        isAudioOn
          ? ButtonId.LiveStream.ButtonTurnOffMic
          : ButtonId.LiveStream.ButtonTurnOnMic
      }
      data-tracking_payload={trackingPayload}
      $hasBorder={hasBorder}
      onClick={onToggleAudio}
      title="microphone"
    >
      <ControlIcon
        src={isAudioOn ? MicrophoneFillIconSrc : MicrophoneSlashFillIconSrc}
        alt=""
      />
    </ControlButton>
    <ControlButton
      data-no-drag
      data-element_id={
        isVideoOn
          ? ButtonId.LiveStream.ButtonTurnOffCamera
          : ButtonId.LiveStream.ButtonTurnOnCamera
      }
      data-tracking_payload={trackingPayload}
      $hasBorder={hasBorder}
      onClick={onToggleVideo}
      title="camera"
    >
      <ControlIcon
        src={isVideoOn ? VideoFillIconSrc : VideoSlashFillIconSrc}
        alt=""
      />
    </ControlButton>
  </>
);

MicVideoButtons.propTypes = {
  isAudioOn: PropTypes.bool,
  isVideoOn: PropTypes.bool,
  hasBorder: PropTypes.bool,
  trackingPayload: PropTypes.object,
  onToggleAudio: PropTypes.func,
  onToggleVideo: PropTypes.func,
};

const ControlButton = styled.button`
  width: 30px;
  height: 30px;
  border: ${({ $hasBorder }) =>
    $hasBorder ? `1px solid ${color.neutral[20]}` : 'none'};
  border-radius: 50%;
  background: ${color.neutral['0_alpha_20']};
  color: ${color.neutral[100]};
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ControlIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  pointer-events: none;
`;

export default MicVideoButtons;
